let cachedPreferences = null;
const listeners = new Set();

export const getCachedUnitPreferences = () => cachedPreferences;

export const setCachedUnitPreferences = (preferences) => {
  cachedPreferences = preferences || null;
  listeners.forEach((listener) => {
    try {
      listener(cachedPreferences);
    } catch (error) {
      console.error('Error notifying unit preferences listener:', error);
    }
  });
};

export const subscribeUnitPreferences = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
